import { useState, useEffect } from 'react';

export const useGeoLocation = () => {
  const [location, setLocation] = useState({ city: '', state: '', loading: true });

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        setLocation({
          city: data.city || '',
          state: data.region_code || '',
          loading: false
        });
      } catch (error) {
        console.error('Failed to fetch GeoIP data', error);
        setLocation({ city: '', state: '', loading: false });
      }
    };
    fetchLocation();
  }, []);

  return location;
};